import { types } from 'utils';
import { partyColors } from './functions';
import { candidates } from './party';

export const data = {
    views: ['Presidential', 'Parliamentary'],
    years: ['2020', '2016', '2012', '2008', '2004', '2000', '1996', '1992'],
    filterYears: ['2024', '2020', '2016', '2012', '2008', '2004', '2000', '1996', '1992'],
};

export const requiredInput = { required: true, message: 'This field is required' };


export const leadingParties = (data: types.RegionalData[]) => {
    if (data.length > 0) {
        let totalVotes = 0;
        const totalValues: Record<string, number> = {};

        let candidateNames: any = data[0]?.candidatenames || {};

        // Iterate over each object in the array
        data.forEach(obj => {
            // Iterate over each key-value pair in the object
            const partyVotes: any = obj.partyvotes;

            for (const key in partyVotes) {
                if (key.length > 1 && typeof partyVotes[key] === 'number') {
                    totalVotes = totalVotes + partyVotes[key];
                    totalValues[key] = (+totalValues[key] || 0) + partyVotes[key];
                }
            }
        });

        const candidate = (c: any) => candidates[c.toLocaleUpperCase() as keyof typeof candidates] || {};
        const sortedValues = Object.entries(totalValues).sort((a, b) => b[1] - a[1]); // Sort parties by vote count descending
        const result: any = {};

        sortedValues.forEach(([party, votes], index) => {
            const percentage = ((votes / totalVotes) * 100).toFixed(2);
            const partyDetails = {
                code: party,
                ...candidate(party).name = candidateNames[party],
                ...candidate(party),
                image: candidate(party)?.partyLogo || '',
                total: votes,
                color: partyColors[party.toLocaleUpperCase() as keyof typeof partyColors] || '#ccc',
                percentage,
            };

            if (index === 0) {
                result.first = partyDetails;
            } else if (index === 1) {
                result.second = partyDetails;
            } else {
                result.other = result.other || { total: 0, percentage: '0.00', parties: [] };
                result.other.total += votes;
                result.other.parties.push(partyDetails);
            }
        });

        if (result.other) {
            result.other.percentage = ((result.other.total / totalVotes) * 100).toFixed(2);
        }

        return result;
    };

}

export const numberFormat = (number: number, decimal = 0) => {
    number = number || 0;
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: decimal === 0 ? 0 : 2, maximumFractionDigits: decimal }).format(number);
}